import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { SelectPicker } from 'rsuite';
import Fancybox from '../../Component/FancyBox';
import Layout from '../../layout/Layout';
import { getUserAllDetail, getUserDetailByEmail, getUserEmails, getUsers } from '../../Auth/Api';
import { GoogleMap, useJsApiLoader, Polygon } from '@react-google-maps/api';



const UsersView = () => {

    const navigate = useNavigate()
    const params = useParams()
    const [userdetails, setUserdetails] = useState([])
    const [selectedEmail, setSelectedEmail] = useState(params.id);
    const [allUsersEmail, setAllUsersEmail] = useState([]);
    const [allEmail, setAllEmail] = useState([]);
    const [selectedName, setSelectedName] = useState([]);
    const [isLoading, setIsLoading] = useState([]);


    const hex = (num) => {
        return `#${Math.abs(num).toString(16)}`;
    }
    useEffect(() => {
        fetchUserDetail(params.id)
        setSelectedEmail(params.id)
        fetchUsers()
    }, [])
    const fetchUserDetail = async (email) => {
        setIsLoading(true)
        const response = await getUserAllDetail(email)
        setUserdetails(response?.data)
        setIsLoading(false)
    }
    useEffect(() => {
        setSelectedName(allEmail?.find((el) => el.email == selectedEmail))
    }, [selectedEmail, allEmail])
    const fetchUsers = async () => {
        const response = await getUserEmails()
        setAllEmail(response?.data?.data)
        setAllUsersEmail(response?.data?.data?.map((item) => ({ label: item.email, value: item.email })))

    }
    const options = {
        disableDefaultUI: true,
        zoomControl: false, // Enable zoom control
        draggable: false,
        mapTypeControl: false,
        streetViewControl: false, // Enable street view control
    };

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyB2dv1u9cWpDgtl_wn2TYXlQFdAspuDSlM"
    })

      
    return (
        <Layout sidebar={true}>
            <div className="page-heading">
                <h3><Link to="/Users" className='btn btn-primary btn-icon-lg me-3'><i className='bx bxs-left-arrow-alt'></i></Link>View Users - <span>{selectedName?.name == "NA" ? `${selectedName?.name} (User login with appleId) ` : selectedName?.name}</span></h3>
                <div className="page-heading-right">
                    <SelectPicker data={allUsersEmail} defaultValue={params.id} onChange={(e) => { fetchUserDetail(e); setSelectedEmail(e); navigate(`/Users/View/${e}`) }} cleanable={false} className="wv-200 my-1 ms-3" placeholder="Select Email Id" placement="bottomEnd" />
                </div>
            </div>
            <div className='page-content'>
                <Card className='mb-3'>
                    <Card.Body>
                        {isLoading && <div className="loader table-loader" ></div>}
                        <h4 className='fw-600 border-bottom pb-3 mb-3'>{userdetails?.group?.length > 0 ? `Group (${userdetails?.group?.length})` : "Group"}</h4>
                        {userdetails?.group?.length > 0 ? userdetails?.group?.map((item, i) => {
                            return (<><Row key={i}>
                                <Col md={4}>
                                    <div className=''>
                                        <p className='mb-0 fw-bold'>Name</p>
                                        <span>{item?.name ? item?.name : "-"}</span>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className=''>
                                        <p className='mb-0 fw-bold'>Email</p>
                                        <span>{item?.email ? item?.email : "-"}</span>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className=''>
                                        <p className='mb-0 fw-bold'>Color</p>
                                        <span><i className='bx bxs-checkbox fs-3' style={{ color: hex(item?.color) }}></i></span>
                                    </div>
                                </Col>
                            </Row>
                                <hr /></>)
                        }) :
                            <div className="no-found py-2">
                                <img src="../../../not-found/group.svg" /><p>No Found Group</p>
                            </div>
                        }
                    </Card.Body>
                </Card>
                <Card className='mb-3'>
                    <Card.Body>
                        <h4 className='fw-600 border-bottom pb-3 mb-3'>{userdetails?.measurement?.length > 0 ? `Measurement (${userdetails?.measurement?.length})` : "Measurement"}</h4>
                        {userdetails?.measurement?.length > 0 ? userdetails?.measurement?.map((item, index) => {
                            // const coordinates = " POLYGON(53.10373895993077 -106.4547437801957, 53.10290923837854 -106.4547907188535, 53.10212640295843 -106.454818546772, 53.101390053631 -106.4547343924642, 53.10073441432997 -106.4547343924642, 53.1001256693549 -106.4547125995159, 53.09995314978448 -106.4548963308334, 53.10002239926342 -106.4560225233436, 53.1001290915564 -106.4572519809008, 53.10016270963919 -106.457601338625, 53.10002421102156 -106.4580412209034, 53.09976935629544 -106.4583064243198, 53.09943981441522 -106.4584375172853, 53.09924112178683 -106.4590648189187, 53.09900136076724 -106.4593890309334, 53.09868308651833 -106.4595388993621, 53.09847311682847 -106.4595821499824, 53.09840366354157 -106.4598785340786, 53.09850673620533 -106.4601501077414, 53.09864745415036 -106.4604461565614, 53.098746701294 -106.4608142897487, 53.09893392144874 -106.4611978456378, 53.0991473111692 -106.4612105861306, 53.09939653291782 -106.4611260965466, 53.09958938688266 -106.4611914753914, 53.09967574813777 -106.4615036174655, 53.09963629173502 -106.4618217945099, 53.09950725294067 -106.4621681347489, 53.09933674398698 -106.4623240381479, 53.09914751247975 -106.4622680470347, 53.09900136076724 -106.4621805399656, 53.09858182609592 -106.4619810506701, 53.09810612036506 -106.4617218822241, 53.09798814936138 -106.4616534858942, 53.09782145940539 -106.4617218822241, 53.0974371439903 -106.462046764791, 53.09716375251678 -106.4626707136631, 53.09697249824409 -106.4636534079909, 53.09686942190454 -106.4648235216737, 53.09679090655832 -106.4653445407748, 53.09677782065334 -106.4659718424082, 53.09683016424933 -106.4663989841938, 53.0969632374893 -106.466676928103, 53.097334270083 -106.466676928103, 53.09811538087384 -106.4666708931327, 53.09901827090814 -106.4666802808642, 53.10002602277959 -106.4666115492582, 53.10089324220708 -106.4665243774652, 53.1009542367873 -106.4660891890526, 53.10092222974112 -106.4654417708516, 53.10063235352152 -106.465418972075, 53.10025289454585 -106.4654303714633, 53.10006668666243 -106.4650743082166, 53.10057035196539 -106.4647299796343, 53.10150861920462 -106.4633050560951, 53.10205957242967 -106.4628698676825, 53.10239332144444 -106.4627780020237, 53.10269506214265 -106.4628360047936, 53.10321178062382 -106.4627102762461, 53.1036034921728 -106.4621594175696, 53.10385027264286 -106.4617145061493, 53.10393139185197 -106.4610137790441, 53.10397386363493 -106.4605524390936, 53.10392837252932 -106.4602238684893, 53.10371581168138 -106.4600384607911, 53.10339696843997 -106.4601480960846, 53.10284039613329 -106.4603754132986, 53.10246095663491 -106.4605608209968, 53.10223812243578 -106.4606704562903, 53.10205091666082 -106.4601309970021, 53.10200542352148 -106.4590775594115, 53.10196999520267 -106.4583443105221, 53.10179808692317 -106.4583526924253, 53.10147922946641 -106.4584958553314, 53.1011430577448 -106.4587691053748, 53.10078514268906 -106.4590882882476, 53.10049244728608 -106.4591483026743, 53.10024323188632 -106.4591124281287, 53.10012043539911 -106.4589377492666, 53.10016955403604 -106.4584633335471, 53.10076581760693 -106.4580241218209, 53.10145970339636 -106.4576509594917, 53.10225100538389 -106.4572114124894, 53.10307107760875 -106.456549577415, 53.10353606006887 -106.4561361819506, 53.10372849289783 -106.4560476690531, 53.10392132744229 -106.4557616785169, 53.10396802628335 -106.4553737640381, 53.10398674606316 -106.4549667388201, 53.10394306656428 -106.4547642320395)"
                            const coordinates = item?.coordinates&&item?.coordinates?.replace("((","(")
                             .match(/\(([^)]+)\)/)[1]
                                .split(',')
                                .map(coord => coord.trim())
                                .map(coord => coord.split(' ').map(parseFloat));
                            let obj = []
                            coordinates?.map((el) =>
                                obj.push({ lat: el[0], lng: el[1] }))
                            return (<><Row key={index}>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Name</p>
                                        <span>{item?.name ? item?.name : "-"}</span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Email</p>
                                        <span>{item?.email ? item?.email : "-"}</span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Group Name</p>
                                        <span>{item?.groupName ? item?.groupName : "-"}</span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-2'>
                                        <p className='mb-1 fw-bold'>Image</p>
                                            {(coordinates?.length > 1 && item?.coordinates)?<div className='measurement-map'>
                                            <a href={`/mapwebview/${JSON.stringify(obj)}`} target="_blank">
                                                {/* <LoadScript googleMapsApiKey="AIzaSyB2dv1u9cWpDgtl_wn2TYXlQFdAspuDSlM"> */}
                                                    {isLoaded &&<GoogleMap
                                                    onResize={false}
                                                    streetView={true}
                                                    center={obj[0]}
                                                    zoom={15}
                                                    mapContainerStyle={{ width: '60px', height: '60px' }}
                                                    options={options}
                                                    >
                                                        <Polygon path={obj} />
                                                    </GoogleMap>}
                                                {/* </LoadScript> */}
                                                </a>
                                            </div>: "-"}
                                    </div>
                                </Col>
                            </Row>
                            <hr />
                            </>)
                        }) :
                            <div className="no-found py-2">
                                <img src="../../../not-found/measurement.svg" /><p>No Found Measurement</p>
                            </div>
                        }
                    </Card.Body>
                </Card>
            </div>
        </Layout>
    )
}

export default UsersView